/* eslint-disable no-useless-escape */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FunctionComponent, useEffect, useState} from 'react';
import {FrequentlyViewedTogetherList} from "@coveo/headless/product-recommendation";
import {pillId, slidderInitialization} from "../../../utils/utils";
import axios from "axios";
import $ from "jquery";
import Product from "./Product";
import * as ReactRedux from "react-redux";
import {setMostPopularResult} from "../../../actions/searchBoxAction";

interface RecommendationsProps {
    openResultMode: boolean;
    controller: FrequentlyViewedTogetherList;
    skus: string[],
    typeFacet?: number
};

export const Recommendations : FunctionComponent<RecommendationsProps> = (props: any) => {
    const { controller, openResultMode,  skus,  typeFacet} = props;
    const [state, setState] = useState(controller.state);
    const [dataFromMagento, setDataFromMagento] = useState([]);
    const dispatch = ReactRedux.useDispatch();
    let isSetInnitSlider = false;
    const isSafari: boolean = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    useEffect(() => {
        if(typeFacet === pillId.PRODUCT && skus.length > 0) {
            controller.setSkus(skus);
            controller.refresh();
        }
    }, [typeFacet, skus]);

    useEffect(() => {
        controller.subscribe(() => setState(controller.state))
    }, [controller]);

    useEffect(() => {
        console.log(controller.state);
        console.log(controller.state.recommendations);
        const skusArray: string[] = [];
        let skuNoUndefined = false;
        let recommendations = controller.state.recommendations;
        if (recommendations && recommendations.length > 0) {
            recommendations.forEach((item: any) => {
                skusArray.push(item?.additionalFields.sku);
                if (!skuNoUndefined && item?.additionalFields.sku) {
                    skuNoUndefined = true;
                }
            });
            dispatch(setMostPopularResult(true));
        }
        const stringConvert: string = skusArray.reduce((stringconverttotal, sku) => (stringconverttotal + `"${sku}"` + ","), "");
        // const domain = "https://webdev.usa.canon.com/shop/att/graphql?";
        //if run product ->
        const domain = `${
        (window.location.hostname === "localhost"
            ? "https://webqa.usa.canon.com"
            : window.location.origin) + "/shop/graphql?"
            }`;
        let query = `{productListInfo(skus:[${stringConvert}]) {products{name sku product_url eight_digits_sku stock_status free_shipping free_shipping_label discontinued_product special_offer price}}}`;
        let queryString = `query=` + encodeURIComponent(query);
        if (skuNoUndefined) {
            axios.get(`${domain + queryString}`)
                .then(res =>
                    setDataFromMagento(res.data.data?.productListInfo?.products)
                );
        }
    }, [controller.state.recommendations]);

    useEffect(() => { console.log(dataFromMagento)}, [dataFromMagento]);

    useEffect(() => {
        if(state.recommendations.length > 0 && !isSetInnitSlider && document.getElementById("products-most-popular")) {
            slidderInitialization($("#products-most-popular"));
            isSetInnitSlider = true;
        }
    }, [state.recommendations]);

    return (
        state.recommendations.length > 0 && openResultMode && (<div id="products-most-popular" className={"products product-grid dynamic-card-carousel d-card-component-container"}>
            <h3 className={"h3 title"}>MOST POPULAR</h3>
            <div className={"cmp-carousel-container"}>
                <div className={"cmp-carousel-wrapper"}>
                    {/*<div className={"slider left-slider"}></div>*/}
                    <ol className="product-result-list cmp-carousel__content">
                        {
                            state.recommendations.map((result: any, index: number) =>
                                (<Product isSafari={isSafari} dataMagento={dataFromMagento ? dataFromMagento : []} result={result} index={index} key={result.ec_item_group_id}></Product>))
                        }
                    </ol>
                    <div className={"scroller-content"}>
                        <div className={"scroller-bar-background"}>
                            <div className={"scroller-bar-background-stripe"}></div>
                        </div>
                        <div className={"scroller-bar"}>
                            <div className={"scroller-bar-stripe"}></div>
                        </div>
                    </div>
                    {/*<div className={"slider right-slider"}></div>*/}
                </div>
            </div>
        </div>)
    );
};
